import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AOS from "aos";

import "./Aircraft.scss";
import AircraftStat from "./../../components/AircraftStat";
import mx9 from "./../../img/aircraft/mx9.jpg";

export default function AircraftAdvanced() {
  useEffect(() => {
    AOS.init({
      easing: "ease",
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Advanced Aircraft | M-Fly</title>
      </Helmet>
      <div className="Aircraft">
        <div className="white-div">
          <div className="clearfix ox aircraft-container">
            <img
              src={mx9}
              alt="MX-9"
              className="float-right"
              data-aos="fade-left"
              data-aos-easing="ease"
              data-aos-duration="2000"
            />
            <div className="info">
              <h1 className="aircraft-name">MX-9</h1>
              <p className="aircraft-description">
                The MX-9 "Phoenix" will be competing in SUAS 2025. It is a
                blended wing body configuration utilizing a carbon fiber
                fuselage to achieve precise airfoil geometry and maximize
                overall performance. Its goal is to autonomously fly through a
                series of waypoints while avoiding dynamic and static
                obstacles, detect targets on the ground using computer vision,
                and drop payloads safely to those targets.
              </p>
            </div>
          </div>
          <div className="stats">
            <AircraftStat value="25 lbs" label="empty weight" />
            <AircraftStat value="34 lbs" label="max takeoff weight" />
            <AircraftStat value="10 ft" label="wingspan" />
            <AircraftStat value="~46 ft/s" label="max flight speed" />
          </div>
        </div>
      </div>
    </>
  );
}
